import React from 'react';
import {LoadingIcon, ueTheme} from 'epic-ue-components';
import styled, {ThemeProvider} from 'styled-components';

const MarketplaceLoading = styled.div`
    .loading-icon-wrap {
        margin: 10em 0;
        .loading-icon-white-bg {
            height: 180px;
            width: 180px;
            margin: 0.5em auto;
        }
    }
`;

const LoadIndicator = () => {
    return (
        <ThemeProvider theme={Object.assign(ueTheme, {ue: {name: 'ueDark'}})}>
            <MarketplaceLoading>
                <LoadingIcon legacy={true} />
            </MarketplaceLoading>
        </ThemeProvider>
    );
};

export default LoadIndicator;
